import { IconFont, pointer, Text } from '@byecode/ui'
import styled, { css } from 'styled-components'

export const UserCenter = styled.div`
    width: 100%;
    height: 48px;
    padding: 4px 8px 4px 4px;

    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    ${pointer}

    &:hover {
        background: var(--color-gray-100);
    }

    &.active {
        background: var(--color-gray-200);
    }
`

export const UserCenterContent = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    overflow: hidden;
`

export const UserName: typeof Text = styled(Text)`
    margin-left: 12px;
    font-size: 16px;
    color: var(--color-gray-900);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`

export const Container = styled.div`
    width: 100%;
    height: 40px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-end;
    align-items: center;
`
